import * as theme from "theme";
import * as React from "react";

export const ReplyIcon = (props:{ color?:string, size?:number }) => {

  const color = props.color ? props.color : theme.Byzantium;
  const size = props.size ? props.size : 11;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size*.818} viewBox="0 0 11 9" fill="none">
          <path
            d="M9.12962 8.73856V6.11147C9.12962 5.74134 9.00323 5.42988 8.75046 5.1771C8.49768 4.92432 8.18622 4.79793 7.81608 4.79793H3.4015L5.04004 6.43647L3.84837 7.62814L0.165039 3.94481L3.84837 0.261475L5.04004 1.45314L3.4015 3.09168H7.81608C8.64664 3.09168 9.35757 3.38734 9.94889 3.97866C10.5402 4.56998 10.8359 5.28092 10.8359 6.11147V8.73856H9.12962Z"
            fill={color}
          />
        </svg>
    );
}
